import React from "react";

const AccountDeletion = () => {
  return (
    <div style={{ padding: "20px", margin: "0 auto" }} className="max-w-6xl">
      <h2
        style={{ lineHeight: "40px", fontSize: "28px", marginBottom: "20px" }}
      >
        {" "}
        Account Deletion Instructions
      </h2>
      <p className="mb-3">
        At <strong>Waggex Payslip</strong>, we respect your privacy and provide
        full control over your account data. If you no longer wish to use our
        services, you can permanently delete your account at any time by
        following the steps below.
      </p>

      <h2>How to Delete Your Account</h2>
      <ol>
        <li style={{ lineHeight: "30px" }}>
          Log in to your Waggex Payslip account.
        </li>
        <li style={{ lineHeight: "30px" }}>
          Go to <strong>Settings → Delete Account</strong>.
        </li>
        <li style={{ lineHeight: "30px" }}>
          Click on the <strong>Delete Account</strong> option.
        </li>
        <li style={{ lineHeight: "30px" }}>
          A confirmation pop-up will appear asking:{" "}
          <em>“Are you sure you want to delete your account?”</em>
        </li>
        <li style={{ lineHeight: "30px" }}>
          Click <strong>Yes</strong> to confirm.
        </li>
        <li style={{ lineHeight: "30px" }}>
          Once confirmed, your account and all associated data will be
          permanently deleted from our system. This action cannot be undone, and
          your payslip history or any saved information will no longer be
          accessible.
        </li>
      </ol>

      <h2>Data Deletion Timeline</h2>
      <p>
        After confirmation, your data will be securely and permanently removed
        from our servers within 7 days.
      </p>

      <h2>Need Help?</h2>
      <p className="mt-4">
        If you face any issues or want to request account deletion manually,
        please contact us at: <br />
        📧{" "}
        <a href="mailto:support@waggex.com" rel="canonical">
          support@waggex.com
        </a>
      </p>
    </div>
  );
};

export default AccountDeletion;
